import { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from "react";
import { useI18n } from "../hooks/useTranslations";

type Page = {
  url?: string;
  title: string;
};

export type PageContextType = {
  page?: Page;
  requestId?: string | number;
  subPath?: string;
  setPage: (page: Page, requestId?: string | number, subPath?: string) => void;
};

const PageContext = createContext<PageContextType>(undefined!);

export const usePageContext = () => useContext(PageContext);

export const PageProvider: FC<PropsWithChildren> = ({ children }) => {
  const i18n = useI18n();
  const [state, setState] = useState<{
    page?: Page;
    requestId?: string | number;
    subPath?: string;
  }>({});

  const setPage = (page: Page, requestId?: string | number, subPath?: string) => {
    setState({ page, requestId, subPath });
  };

  useEffect(() => {
    document.title = "Warehouse Processings";
    if (state.page?.title) {
      document.title += ": " + state.page.title.trim();
    }

    // if it is the staging environment the document.titel is changed accordingly
    if (import.meta.env.MODE === "staging" && !document.title.includes(i18n.t.common.testEnvironment)) {
      document.title += " - " + i18n.t.common.testEnvironment;
    }
  }, [state.page?.title]);

  return (
    <PageContext.Provider value={{ page: state.page, requestId: state.requestId, subPath: state.subPath, setPage }}>
      {children}
    </PageContext.Provider>
  );
};

export default PageContext;
